@if (reference) {
  <div
    class="chat-context-ref border rounded d-flex align-items-center gap-2 p-2 mt-1"
  >
    <span class="avatar-xs rounded bg-soft-primary flex-shrink-0">
      <i class="avatar-title text-primary font-16" [ngClass]="icon"></i>
    </span>

    <div class="flex-grow-1 overflow-hidden">
      <small class="text-muted d-block text-uppercase chat-context-ref__kind">{{
        kindLabelKey | translate
      }}</small>
      <small class="d-block text-truncate fw-semibold">{{ label }}</small>
      @if (subtitle) {
        <small class="text-muted d-block text-truncate">{{ subtitle }}</small>
      }
    </div>

    @if (removable) {
      <button
        type="button"
        class="btn btn-sm chat-context-ref__action flex-shrink-0"
        [matTooltip]="'chat.contextRef.remove' | translate"
        [attr.aria-label]="'chat.contextRef.remove' | translate"
        (click)="remove.emit()"
      >
        <i class="ri-close-line"></i>
      </button>
    } @else if (navigable) {
      <button
        type="button"
        class="btn btn-sm chat-context-ref__action flex-shrink-0"
        [matTooltip]="'chat.contextRef.open' | translate"
        [attr.aria-label]="'chat.contextRef.open' | translate"
        (click)="open()"
      >
        <i class="ri-external-link-line"></i>
      </button>
    }
  </div>
}
